import React from "react";
import { CreateComponentProps } from "./CreateDashboardComponentTab";
import { Button } from "@aidkitorg/component-library";
import { useDashboards } from "../../../Contexts/DashboardsContext";
import { createStagedComponent } from "@aidkitorg/types/lib/admin-panel/dashboard";
import { useMapFormState } from "../hooks/useMapFormState";
import { MapFormFields } from "./MapFormFields";
import { useLocalizedStrings } from "../../../Localization";

export const MapComponentConfig: React.FC<CreateComponentProps> = ({ setDisplayMode }) => {
  const L = useLocalizedStrings()

  const {
    title, setTitle,
    description, setDescription,
    geographicDataOption, setGeographicDataOption,
    addressField, setAddressField,
    geoJSONUrl, setGeoJSONUrl,
    buildMapObject
  } = useMapFormState()

  const { 
    setStagedComponents,
    getDashboardComponentTranslation
  } = useDashboards()

  const saveMapComponent = async () => {
    const newMap = buildMapObject()

    const translations = await getDashboardComponentTranslation(newMap)

    if (translations && translations.success) {
      const stagedComponent = createStagedComponent(newMap, translations.data)
      setStagedComponents((prevState) => ([...prevState, stagedComponent]))
      setDisplayMode('create')
    } else {
      // TODO: handle error
      console.error('Failed to translate map component:', newMap)
    }
  }

  const isSaveDisabled = title === '' || 
    (geographicDataOption === 'point' && addressField === '') ||
    (geographicDataOption === 'polygons' && (geoJSONUrl === ''))
    
  return (
    <div className="flex flex-col gap-y-2">
      <div className="text-xl font-bold text-gray-900">
        {L.admin_panel.dashboards.add_map}
      </div>

      <MapFormFields 
        title={title}
        setTitle={setTitle}
        description={description}
        setDescription={setDescription}
        geographicDataOption={geographicDataOption}
        addressField={addressField}
        setAddressField={setAddressField}
        setGeographicDataOption={setGeographicDataOption}
        geoJSONUrl={geoJSONUrl}
        setGeoJSONUrl={setGeoJSONUrl}
      />

      <div className="flex justify-between gap-x-2 pt-2">
        <Button onClick={() => setDisplayMode('create')} className="!w-1/2" variant="secondary">{L.admin_panel.dashboards.cancel}</Button>
        <Button isDisabled={isSaveDisabled} onClick={saveMapComponent} className="!w-1/2">{L.admin_panel.dashboards.save}</Button>
      </div>
    </div>
  )
}